import { HeaderCommonProps } from "@components/Header/types";
import IconFactory from "@components/Icon/IconFactory";
import { IconTypeEnum } from "@components/Icon/utils/types";
import { cn } from "@util/helpers";
import cx from "classnames";

export type ToggleSideMenuButtonProps = {
  onClick: () => void;
  rootClassName?: string;
} & Pick<HeaderCommonProps, "textClassName">;

export default function ToggleSideMenuButton({
  onClick,
  rootClassName,
  textClassName = "text-gray-850",
}: ToggleSideMenuButtonProps): React.ReactElement {
  return (
    <button
      aria-label="Toggle side menu"
      className={cx(
        "block flex-none cursor-pointer opacity-100 duration-300",
        "border-0 p-1 !outline-none focus-within:outline-0 focus:outline-0 lg:hover:rounded-full lg:hover:bg-gray-250",
        rootClassName
      )}
      onClick={onClick}
    >
      <IconFactory
        type={IconTypeEnum.hamburgerForDesktop}
        size={24}
        className={cn("hidden lg:block", textClassName)}
      />

      <IconFactory
        type={IconTypeEnum.hamburgerForMobile}
        size={24}
        className={cn("block lg:hidden", textClassName)}
      />
    </button>
  );
}
